<script setup>
import {computed} from "vue";
import {useStore} from "vuex";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import useInstallation from "@/composables/optimizer/useOnsiteOptimizer";
import OptimizerChecklist from "@/components/onsiteOptimizer/installation/partials/OptimizerChecklist.vue";
import VendastaWarningModal from "@/components/onsiteOptimizer/installation/modals/VendastaWarningModal.vue";
import AwaitingInstallationModal from "@/components/onsiteOptimizer/installation/modals/AwaitingInstallationModal.vue";

const {
  beginInstallation,
  assistedInstallation,
  showInstallForMeButton,
  showAwaitingInstallationModal,
  showVendastaModal,
  optimiserInstalled,
} = useInstallation();

const store = useStore();
const emit = defineEmits(['nextStep', 'goToAssisted']);
const user = computed(() => store.getters['user/user']);
</script>

<template>
  <div
    v-if="user"
    class="tw-flex tw-flex-col tw-gap-8"
  >
    <OptimizerChecklist class="tw-text-font-secondary tw-text-base tw-text-left" />

    <div v-if="optimiserInstalled">
      <p class="tw-text-everest-bright tw-text-lg tw-text-center">
        Onsite Optimizer successfully installed, continue below
      </p>
    </div>

    <div
      v-else
      class="tw-flex tw-flex-col tw-gap-4 tw-items-center"
    >
      <p class="tw-text-font-secondary tw-text-base">
        Please choose your installation method below, and let’s get started!
      </p>

      <div class="tw-flex tw-gap-4 tw-justify-center">
        <DefaultButton
          class="tw-py-2"
          @click="beginInstallation(emit)"
        >
          I'll install the snippet myself
        </DefaultButton>

        <DefaultButton
          v-if="showInstallForMeButton"
          class="tw-py-2"
          variant="primary-inverted"
          @click="assistedInstallation(emit)"
        >
          I want you to install it for me
        </DefaultButton>
      </div>
    </div>
  </div>

  <VendastaWarningModal
    v-if="showVendastaModal"
    @confirm="emit('nextStep')"
    @close="showVendastaModal = false"
  />

  <AwaitingInstallationModal
    v-if="showAwaitingInstallationModal"
    @confirm="emit('nextStep')"
    @close="showAwaitingInstallationModal = false"
  />
</template>
